var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tree',{staticClass:"treeMenuContainer",attrs:{"data":_vm.formattedTreeData,"props":_vm.treeProps,"highlight-current":"","node-key":"id"},on:{"node-click":_vm.handleNodeClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }